import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  AuthProvider,
  APIProvider,
  LoadingScreen,
  MegaWrapper,
  accessControl,
  FeatureProvider,
  ImpersonationWrapper,
} from '@monash/portal-frontend-common';
import homeLoading from './assets/lotties/home-loading.json';
import { Router } from '@monash/portal-react';
import { FEATURE_FLAGS } from '@/constants/features';

const container = document.getElementById('root');
const root = createRoot(container);

const loadingScreen = <LoadingScreen animation={homeLoading} />;

const wrappers = [
  {
    comp: AuthProvider,
    props: {
      nolanding: true,
      loadingPage: loadingScreen,
      accessControl: accessControl.isStudent,
    },
  },
  {
    comp: FeatureProvider,
    props: {
      defaultFeatures: FEATURE_FLAGS,
    },
  },
  React.StrictMode,
  APIProvider,
  ImpersonationWrapper,
  Router,
];

root.render(
  <MegaWrapper providers={wrappers}>
    <App />
  </MegaWrapper>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
